<template>
    <div id="loading-bg">
        <span class="bootstrap-vue-spinner-border primary"></span>
    </div>
</template>

<script>
import { InboxModulePathType } from "@saysimple-platform/dtos";

export default {
    mounted() {
        this.$auth.$watch(
            "loading",
            async (isLoading) => {
                if (isLoading === false) {
                    this.$router.push({ name: InboxModulePathType.MESSAGING });
                }
            },
            {
                immediate: true,
            }
        );
    },
};
</script>
